import "../src/index.css"

import { CacheProvider, EmotionCache } from "@emotion/react"
import { HydrationBoundary, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import React from "react"
import App from "src/App"
import { ThemeProvider } from "src/ThemeProvider"
import { isProduction } from "src/utils/utils"
import { usePageContext } from "vike-react/usePageContext"

import { AnalyticsProvider } from "../src/AnalyticsProvider"
import createEmotionCache from "../src/createEmotionCache"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
    },
  },
})

interface LayoutDefaultProps {
  children: React.ReactNode
  emotionCache?: EmotionCache
}

export default function LayoutDefault({
  children,
  emotionCache = createEmotionCache(),
}: LayoutDefaultProps) {
  const pageContext = usePageContext()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dehydratedReactQuery = (pageContext.data as any)?.dehydratedReactQuery
  React.useEffect(() => {
    if (dehydratedReactQuery && !isProduction) {
      console.log("Hydrating with SSR data:", dehydratedReactQuery)
    }
  }, [dehydratedReactQuery])

  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider>
        <AnalyticsProvider>
          <QueryClientProvider client={queryClient}>
            <HydrationBoundary state={dehydratedReactQuery}>
              <App>{children}</App>
            </HydrationBoundary>
          </QueryClientProvider>
        </AnalyticsProvider>
      </ThemeProvider>
    </CacheProvider>
  )
}
